<template>
  <div class="mains">
    <div class="campus">
      教材管理
      <span>></span>
      <router-link to="selfbook">自制教材区</router-link>
      <span>></span>添加自制教材
    </div>
    <div class="xiaoqu moerduo">
      <el-card :span="24">
        <div class="grid-content bg-purple scrollbarStyle test-2">
          <div class="xiaoqu_1">自制教材</div>
          <div class="zizhi_zz">
            <div>
              <img src="@/assets/img/textbook-manage/schoolbook/zz_kb.png" />
              <el-button type="primary" class="buttons xj_wjj zz_tianjia zz_keben" @click="zzkb">
                制作课本
              </el-button>
            </div>
            <div class="zizhi_zz_2">
              <img src="@/assets/img/textbook-manage/schoolbook/zz_kj.png" />
              <el-button type="primary" class="buttons xj_wjj zz_tianjia zz_keben" @click="zzkj">
                制作课件
              </el-button>
            </div>
            <div class="zizhi_zz_2">
              <img src="@/assets/img/textbook-manage/schoolbook/bz_zx.png" />
              <el-button type="primary" class="buttons xj_wjj zz_tianjia zz_keben" @click="bzzx">
                帮助中心
              </el-button>
            </div>
          </div>
        </div>
      </el-card>

      <el-card :span="24" class="cj_wt">
        <div class="grid-content bg-purple scrollbarStyle test-2">
          <div class="xiaoqu_1">常见问题</div>
          <div class="cjwt_1">
            <h3>1、关于素材上传的路径及格式问题？</h3>
            <span>
              您制作自制课本及自制教材所需要的素材主要分为三部分，包括图片、音频及视频这三大类型；
            </span>
            <span>
              素材由先上传至素材中心进行分组、分类整理，后期由素材中心导入您所需要的素材；（简单的封面图片您可进行自主上传路径）
            </span>
            <span>
              素材上传路径为：素材中心 — 整理分累 —
              由素材中心导入至所需要的地点。
            </span>
          </div>
          <div class="cjwt_1 cjwt_2">
            <h3>
              2、编辑单元、章节中的“添加音频”与“添加视频”这两个功能是什么呢？
            </h3>
            <span>
              您所选择的单元既是您要编辑的部分，而您将要添加的独立视频和音频也将归属于该单元下；
            </span>
            <span>
              “添加音频”为您为此单元所上传的独立音频文件，您所上传的音频将在小程序端的"磨耳朵"板块展出；
            </span>
            <span>
              “添加视频”同理，您所上传的视频将在小程序端的"微剧场"板块展出；且以您选择的“单元”或“章节”为单位展示。
            </span>
          </div>
          <div class="cjwt_1 cjwt_2">
            <h3>3、关于素材上传的路径及格式问题？</h3>
            <span>
              您制作自制课本及自制教材所需要的素材主要分为三部分，包括图片、音频及视频这三大类型；
            </span>
            <span>
              素材由先上传至素材中心进行分组、分类整理，后期由素材中心导入您所需要的素材；（简单的封面图片您可进行自主上传路径）
            </span>
            <span>
              素材上传路径为：素材中心 — 整理分累 —
              由素材中心导入至所需要的地点。
            </span>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'selfbookadd',
  data() {
    return {
      addbookIds: true,
    };
  },
  watch: {},
  created() {},
  methods: {
    zzkb() {
      var addbookId = this.addbookIds;
      this.$store.commit('addbookId', addbookId);
      this.$router.push({
        path: '/addBook',
      });
    },
    zzkj() {},
    bzzx() {},
  },
};
</script>

<style lang="less">
.cj_wt {
  margin-top: 20px;
  .cjwt_1 {
    width: 1551px;
    height: 167px;
    background: #f2f2f2;
    margin-left: 10px;
    font-size: 14px;
    color: #999;
    padding: 13px 0 0 35px;
    margin-top: 20px;
    h3 {
      color: #00a6e6;
      font-size: 16px;
    }
    span {
      display: block;
      margin-top: 10px;
    }
  }
  .cjwt_2 {
    margin-top: 15px;
  }
}

.zizhi_zz {
  .zizhi_zz_2 {
    margin-left: 44px;
  }
  div {
    width: 500px;
    height: 250px;
    background: rgba(248, 248, 248);
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    float: left;
    text-align: center;
    opacity: 1;
    margin: 10px 0 89px 15px;
    img {
      margin-bottom: 30px;
      width: 298px;
      height: 240px;
    }
    .zz_keben {
      display: block;
      margin: 0 auto;
      width: 150px;
      height: 40px;
      border-radius: 999px;
      font-size: 16px !important;
      font-weight: bold;
    }
  }
}
</style>
